import createReactComponent from '../createReactComponent';
export default createReactComponent('basket-discount', 'IconBasketDiscount', [
  ['path', { d: 'M7 10l5 -6l5 6', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M12 20h-5c-.966 .024 -1.807 -.817 -2 -2l-2 -8h18l-.644 2.577',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M13.448 13.62a2 2 0 1 0 -.823 3.28', key: 'svg-2' }],
  ['path', { d: 'M16 21l5 -5', key: 'svg-3' }],
  ['path', { d: 'M21 21v.01', key: 'svg-4' }],
  ['path', { d: 'M16 16v.01', key: 'svg-5' }],
]);
